// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 21) return "static/js/80baa4a124ea5de5eafa.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"c2e342ae7345b53eef01","141":"78505a1acebae997203a","142":"402ee8f17ae3c9d72a6c"}[chunkId] + ".chunk.js";
};